// ** React Imports
import { lazy } from 'react';

const CurrencyRoutes = [
  {
    path: 'currencies',
    component: lazy(() => import('pages/currency')),
  },
];

export default CurrencyRoutes;
